import usePageMeta from '../hooks/usePageMeta';
import { opt } from '../lib/media';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, Quote } from 'lucide-react';
import { fetchHappyClients } from '../api';
import ClientReviewsWall from '../components/ClientReviewsWall';

function Stars({ value }) {
  return (
    <div className="flex gap-0.5 justify-center">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} size={15} className={n <= value ? 'fill-gold text-gold' : 'fill-transparent text-burgundy-900/25'} />
      ))}
    </div>
  );
}

export default function HappyClients() {
  usePageMeta('Happy Clients | Hitera Designer Wear', 'Real clients wearing Hitera — reviews and stories from our luxury designer wear family across India.');
  const [clients, setClients] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchHappyClients().then((d) => setClients(Array.isArray(d) ? d : [])).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  return (
    <div className="bg-white">
      <div className="relative h-[42vh] overflow-hidden bg-burgundy-950">
        <div className="absolute inset-0 bg-gradient-to-t from-burgundy-950 via-burgundy-900/60 to-burgundy-950" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <p className="text-gold tracking-luxe text-xs uppercase mb-3 fade-up">Real Women · Real Moments</p>
          <h1 className="font-display text-5xl md:text-6xl text-cream fade-up">Happy Clients</h1>
          <p className="text-cream/70 mt-3 text-sm max-w-lg fade-up">The women who wear HITÉRA — and the stories they carry.</p>
        </div>
      </div>

      <div className="max-w-[1300px] mx-auto px-4 md:px-8 py-16 md:py-20">
        {!loaded ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[4/5] skeleton" />)}
          </div>
        ) : clients.length === 0 ? (
          <div className="text-center py-6">
            <Link to="/review" data-testid="happy-clients-share-link" className="inline-block bg-burgundy-900 text-cream px-9 py-3.5 text-xs tracking-wideluxe uppercase hover:bg-burgundy-800 transition-colors">Share Your HITÉRA Story</Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {clients.map((c) => (
              <div key={c.id} className="group fade-up bg-cream/40 overflow-hidden flex flex-col">
                <div className="img-zoom relative aspect-[4/5] overflow-hidden bg-cream">
                  {c.image && <img src={opt(c.image, 600)} alt={c.name} loading="lazy" decoding="async" width="480" height="600" className="w-full h-full object-cover" />}
                </div>
                <div className="p-6 flex-1 flex flex-col text-center">
                  <Quote size={22} className="text-gold-dark mx-auto mb-3" />
                  <p className="text-burgundy-900/75 text-sm leading-relaxed italic flex-1">“{c.testimonial}”</p>
                  <div className="mt-4"><Stars value={c.rating || 5} /></div>
                  <p className="font-display text-xl text-burgundy-900 mt-3">{c.name}</p>
                  {c.occasion && <p className="text-[11px] tracking-wideluxe uppercase text-gold-dark mt-1">{c.occasion}</p>}
                  {c.productId && (
                    <Link to={`/product/${c.productId}`} className="inline-block mt-4 text-xs tracking-wideluxe uppercase border-b border-gold text-burgundy-900 pb-1 hover:text-gold-dark transition-colors self-center">Shop This Look</Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <ClientReviewsWall />
    </div>
  );
}
